import { Component, OnInit, ViewChild } from '@angular/core';
import { IntentService } from '../../../services/intent.service';
import { ClientSideRowModelModule, ColumnAutoSizeModule, CustomFilterModule, GridApi, GridOptions, ICellRendererParams, PaginationModule, RowSelectionModule, TextFilterModule, ValidationModule } from 'ag-grid-community';
import { AgGridModule, ICellRendererAngularComp } from 'ag-grid-angular';
import { Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-intent-list',
  imports: [RouterModule, CommonModule, FormsModule, AgGridModule],
  templateUrl: './intent-list.component.html',
  styleUrl: './intent-list.component.scss'
})
export class IntentListComponent implements OnInit {
  @ViewChild('deleteConfirmModal') deleteModal!: any;

  modules = [ClientSideRowModelModule, ValidationModule, CustomFilterModule, TextFilterModule, ColumnAutoSizeModule, RowSelectionModule, PaginationModule];

  gridApi: GridApi | undefined;
  gridOptions: GridOptions | undefined;
  
  intents: any[] = [];
  filteredIntents: any[] = [];
  groups: { key: number, value: string }[] = [];
  selectedGroup: string | null = null;
  searchQuery: any;

  rowSelection: any = { mode: 'singleRow', checkboxes: false, headerCheckbox: false };

  constructor(private service: IntentService, private modalService: NgbModal, private router: Router) {
    this.gridOptions = this.initializeGridOptions();
  }

  ngOnInit(): void {
    this.loadIntents();
    this.loadGroups();
  }


  initializeGridOptions(): GridOptions {
    return {
      columnDefs: [
        { field: 'description', sortable: true, filter: true, resizable: true, flex: 1 },
        { field: 'qualifiedName', sortable: true, filter: true, resizable: true, width: 200 },
        { field: 'sampleQuestion', sortable: true, filter: true, resizable: true, flex: 1 },
        { field: 'sampleAnswer', sortable: true, filter: true, resizable: true, flex: 1 },
        { 
          field: 'groupName', 
          headerName: 'Group', 
          sortable: true, 
          filter: true, 
          resizable: true, 
          width: 150 
        },
        {
          field: 'id',
          headerName: 'Actions',
          headerClass: 'header-center',
          cellRenderer: IntentActionsCellRenderer,
          cellRendererParams: {
            context: {
              onDeleteAction: this.openDeleteModal.bind(this),
              onEditAction: this.onUpdateItem.bind(this)
            }
          },
          resizable: true,
          width: 110,
          pinned: 'right'
        }
      ]
    };
  }

  onGridReady(params: any) {
    this.gridApi = params.api;
  }

  loadIntents() {
    this.gridApi?.setGridOption('loading', true);
    this.service.getAll().subscribe({
      next: (data: any[]) => {
        this.intents = data;
        this.filteredIntents = [...this.intents];
        this.gridApi?.setGridOption("rowData", this.filteredIntents);   
      },
      complete: () => this.gridApi?.setGridOption('loading', false),
      error: (error: any) => {
        console.error('Error fetching intents:', error);
        this.gridApi?.setGridOption('loading', false);
      }
    });
  }

  loadGroups() {
    this.service.getIntentGroups().subscribe({
      next: (groups) => {
        this.groups = groups;
      },
      error: (error) => console.error('Error fetching groups:', error)
    });
  }

  filterIntents(): void {

    let filtered = [...this.intents];

    if (this.selectedGroup) {
      filtered = filtered.filter(item => item.groupName === this.selectedGroup);
    }

    // Apply search filter
    if (this.searchQuery) {
      const query = this.searchQuery.toLowerCase();
      filtered = filtered.filter(item =>
        Object.values(item).some(value =>
          value?.toString().toLowerCase().includes(query)
        )
      );
    }

    this.filteredIntents = filtered;
    this.gridApi?.setGridOption("rowData", this.filteredIntents);
  }

  selectGroup(group: string | null) {
    this.selectedGroup = group;
    this.filterIntents();
  }

  clearSearch(): void {
    this.searchQuery = '';
    this.filteredIntents = [...this.intents];
  }

  confirmDeleteItem(modal: any) {
    this.service.delete(this.deleteModal.idToDelete).subscribe({
      next: () => this.loadIntents(),
      error: (error: any) => console.error('Error deleting intent:', error),
      complete: () => modal.close()
    });
  }

  openDeleteModal(item: any) {
    this.deleteModal.idToDelete = item.id;
    this.modalService.open(this.deleteModal, { centered: true });
  }

  onUpdateItem(item: any): void {
    this.router.navigate(['/intent/edit', item.id]);
  }
}


/** Actions Cell Renderer Component */
@Component({
  standalone: true,
  selector: 'IntentActionsCellRenderer',
  template: `
    <button class="btn btn-sm btn-primary me-1" (click)="onEdit()"><i class="bi bi-pencil"></i></button>
    <button class="btn btn-sm btn-danger" (click)="onDelete()"><i class="bi bi-trash"></i></button>
  `
})
export class IntentActionsCellRenderer implements ICellRendererAngularComp {
  params!: ICellRendererParams;

  agInit(params: ICellRendererParams): void {
    this.params = params;
  }

  onDelete() { this.params.context.onDeleteAction(this.params.data); }
  onEdit() { this.params.context.onEditAction(this.params.data); }
  refresh(params: ICellRendererParams) { return true; }
}